import {
  setBankUploading,
  stateLoaderBankUploading,
  setBankUploadingById,
} from "./actions";
import { call, put, takeEvery, select } from "redux-saga/effects";
import {
  getBankUploading,
  patchBankUploading,
  deleteBankUploading,
  getBankUploadingById,
} from "../../helpers/jwt_helper.js";
import {
  GET_BANK_UPLOADING,
  UPDATE_BANK_UPLOADING,
  DELETE_BANK_UPLOADING,
  GET_BANK_UPLOADING_ID,
} from "./actionType";
import {
  showErrorMessage,
  getErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";
import { take } from "lodash";

function* onGetBankUploading({ payload: data }) {
  try {
    yield put(stateLoaderBankUploading());
    let response = yield call(getBankUploading, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      client: data.client || "",
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }
    yield put(setBankUploading(response));
    yield put(stateLoaderBankUploading());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(stateLoaderBankUploading());
  }
}

function* onGetBankUploadingById({ payload: id }) {
  try {
    yield put(stateLoaderBankUploading());
    let res = yield call(getBankUploadingById, id);
    yield put(setBankUploadingById(res));
    yield put(stateLoaderBankUploading());
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(stateLoaderBankUploading());
  }
}

function* onUpdateBankUploading({ payload: { id, data } }) {
  try {
    yield put(stateLoaderBankUploading());
    yield call(patchBankUploading, id, data);
    yield call(onGetBankUploading, { payload: data });
    yield put(stateLoaderBankUploading());
    showSuccessMessage(`Updating payment for client has been successfully`);
  } catch (e) {
    showErrorMessage(getErrorMessage(e));
    yield put(stateLoaderBankUploading());
  }
}

function* onDeleteBankUploading({ payload: id }) {
  try {
    let data = yield select(state => state.BankUploading.data);
    yield put(stateLoaderBankUploading());
    yield call(deleteBankUploading, id);
    yield call(onGetBankUploading, { payload: data });
    showSuccessMessage(`Deleting payment information has been successfully`);
    yield put(stateLoaderBankUploading());
  } catch (e) {
    yield put(stateLoaderBankUploading());
    showErrorMessage(getErrorMessage(e));
  }
}

function* bankUploadingSaga() {
  yield takeEvery(GET_BANK_UPLOADING, onGetBankUploading);
  yield takeEvery(GET_BANK_UPLOADING_ID, onGetBankUploadingById);
  yield takeEvery(UPDATE_BANK_UPLOADING, onUpdateBankUploading);
  yield takeEvery(DELETE_BANK_UPLOADING, onDeleteBankUploading);
}

export default bankUploadingSaga;
